'use client'

import TextInput from '../../../../shared/components/inputs/text-input'
import { Button } from '../../../../shared/components/ui/button'
import { AUTH_PAGE_ROUTE } from '../../../../shared/constants/pages-routes'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import React, { useState } from 'react'
import { forgotPassword } from '../../actions/auth.action'
import { toast } from 'sonner'
import errorToast from '../../../../shared/lib/toast/error.toast'

function ForgotPasswordForm() {
    const [email, setEmail] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const router = useRouter()

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        try {
            setIsLoading(true)
            const res = await forgotPassword(email)
            console.log(res,'resssssforgot')
            if(!res.success) throw new Error(res.message)
            router.push(AUTH_PAGE_ROUTE.successfullySent)

        } catch (e) {
            const error = e as Error
            errorToast(error.message)

        } finally {
            setIsLoading(false)
        }
    }

    return (
        <form onSubmit={onSubmit} className='flex flex-col gap-8 w-full'>
            <TextInput
                label='Email Address'
                type='email'
                placeholder='Email*'
                value={email}
                onChange={(e) => setEmail(e.currentTarget.value)}
                required
            />
            <Button type='submit' disabled={isLoading} showLoader>
                Send Email
            </Button>
        </form>
    )
}

export default ForgotPasswordForm